import { CustomerQuery } from '@src/graphql/generated';
import { hasFields } from '@src/util/object/helpers';

type PlanInfo = CustomerQuery['customer']['planInfo'];
type SubscriptionPlan = Extract<PlanInfo, { __typename?: 'SubscriptionPlanType' }>;

export function isSubscriptionPlanType(planInfo: PlanInfo): planInfo is SubscriptionPlan {
  return hasFields<SubscriptionPlan>(planInfo, ['__typename']) && planInfo?.__typename === 'SubscriptionPlanType';
}
